var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknowType({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00806 10.3725C8.16904 9.9149 8.48679 9.52901 8.90503 9.28321C9.32327 9.03741 9.815 8.94756 10.2931 9.02957C10.7713 9.11159 11.205 9.36017 11.5174 9.7313C11.8298 10.1024 12.0008 10.5721 12.0001 11.0573C12.0001 12.4267 9.94586 13.1115 9.94586 13.1115",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 15.0288H10.0076",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.6665H4.66667C4.22464 1.6665 3.80072 1.8421 3.48816 2.15466C3.17559 2.46722 3 2.89114 3 3.33317V16.6665C3 17.1085 3.17559 17.5325 3.48816 17.845C3.80072 18.1576 4.22464 18.3332 4.66667 18.3332H15.3333C15.7754 18.3332 16.1993 18.1576 16.5118 17.845C16.8244 17.5325 17 17.1085 17 16.6665V6.99982L12 1.6665Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2V7H17",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknowType);
export default __webpack_public_path__ + "static/media/unknowType.49060f9d.svg";
export { ForwardRef as ReactComponent };